import auth0 from "auth0-js"
let webAuth0 = new auth0.WebAuth({
	domain: "dev-ayzgkh29.eu.auth0.com",
	clientID: "PXzjJa5QilNGQDSR7ktJyy9gM8uaq5qM",
	responseType: "token id_token",
	redirectUri: window.location.origin + "/callback"
})

let config = {
	s3: {
		bucket: "biosci-staging-mma2",
		region: "us-east-1"
	},
	SES: {
		REGION: "us-west-2"
	},
	appsyncunAuth: {
		graphqlEndpoint:
			"https://kt57c76qqfao7oseyjsqwq2xea.appsync-api.us-east-1.amazonaws.com/graphql",
		region: "us-east-1",
		authenticationType: "API_KEY",
		apiKey: "da2-q44gorf7dbhwvl4s6psrnurd6y"
	},
	appsyncAuth: {
		graphqlEndpoint:
			"https://dn5tub4izbaahfobvscteox7my.appsync-api.us-east-1.amazonaws.com/graphql",
		region: "us-east-1",
		authenticationType: "AWS_IAM"
	},
	auth: {
		identityPoolId: "us-east-1:a567e2da-431a-465b-a459-de9535d5fb1c",
		region: "us-east-1",
		userPoolId: "us-east-1_XQmMUquXl",
		userPoolWebClientId: "19j5u5csmaqa6ssv1rmrpscr7r",
		mandatorySignIn: true,
		refreshHandlers: {
			"dev-ayzgkh29.eu.auth0.com": () =>
				new Promise((res, rej) => {
					webAuth0.renewAuth(
						{
							domain: "dev-ayzgkh29.eu.auth0.com",
							clientID: "PXzjJa5QilNGQDSR7ktJyy9gM8uaq5qM",
							responseType: "token id_token"
						},
						(err, data) => {
							if (err) {
								rej(err)
							}
							res(data)
						}
					)
				})
		},
		social: {
			FB: "540123446725115",
			GM:
				"32423559507-du6k6e8khk5if6gmulmhs69av6qdkvdl.apps.googleusercontent.com",
			webAuth0,
			openid: "dev-ayzgkh29.eu.auth0.com"
		}
	}
}
export default config
